import { render, staticRenderFns } from "./CalendarLegend.vue?vue&type=template&id=7f98df73"
import script from "./CalendarLegend.vue?vue&type=script&lang=js"
export * from "./CalendarLegend.vue?vue&type=script&lang=js"
import style0 from "./CalendarLegend.vue?vue&type=style&index=0&id=7f98df73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports